import(/* webpackMode: "eager" */ "/src/src/app/(staitc-page)/privacy-security/pc.module.scss");
;
import(/* webpackMode: "eager" */ "/src/src/app/(staitc-page)/privacy-security/wap.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
